import { Component, OnDestroy } from '@angular/core';
import { NbTokenService } from '@nebular/auth';
import { NbMenuItem, NbMenuService, NbSidebarService } from '@nebular/theme';
import { ChatService } from 'app/@chat/chat.service';
import { IChatThread, IChatUser } from 'app/@chat/domain';
import { PatientsService } from 'app/@core/backend/common/services/CalorieFriend/patients.service';
import { NativeAppService } from 'app/@core/backend/common/services/native-app.service';
import { PatientData } from 'app/@core/interfaces/common/CalorieFriend/patients';
import { User } from 'app/@core/interfaces/common/users';
import { LayoutService } from 'app/@core/utils';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BehaviorSubject, merge, Subject } from 'rxjs';
import { map, switchMap, takeWhile, filter, scan } from 'rxjs/operators';
import { InitUserService } from '../@theme/services/init-user.service';
import { PagesMenu } from './pages-menu';

@Component({
  selector: 'ngx-pages',
  styleUrls: ['pages.component.scss'],
  templateUrl: './pages.component.html',
})
export class PagesComponent implements OnDestroy {
  menu: NbMenuItem[];
  alive: boolean = true;
  isChatActive: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(
    private pagesMenu: PagesMenu,
    private tokenService: NbTokenService,
    protected initUserService: InitUserService,
    private layoutService: LayoutService,
    private nativeApp: NativeAppService,
    leftMenu: NbMenuService,
    private sidebarService: NbSidebarService,
    deviceService: DeviceDetectorService,
    private patientsSerivce: PatientData,
    private chatService: ChatService
  ) {
    this.initMenu();

    this.tokenService
      .tokenChange()
      .pipe(takeWhile(() => this.alive))
      .subscribe(() => {
        this.initMenu();
      });

    leftMenu.onItemClick().subscribe(() => {
      if (deviceService.isMobile() || this.nativeApp.isFromApp()) {
        sidebarService.collapse('menu-sidebar');
        this.layoutService.changeLayoutSize();
      }
    });

    this.initChatApp();

    this.patientsSerivce.onUpdated$
      .subscribe({
        next: () => {
          this.patientsSerivce
            .getActiveCount()
            .pipe(
              switchMap((count) => {
                return this.patientsSerivce.list({
                  isArchived: false,
                  isDemo: false,
                  pageNumber: 1,
                  pageSize: count,
                  orderBy: 'asc',
                  sortBy: 'name',
                });
              }),
              map((patients) => {
                return patients.items.map<IChatUser>((p) => ({
                  id: p.id,
                  uid: `p_${p.id}`,
                  name: p.name,
                  lastSeen: p.lastTimeSeen,
                  active: true,
                  avatar: '',
                }));
              }),
              map((users) => {
                return users.map<IChatThread>((u) => ({
                  id: u.id,
                  name: u.name,
                  users: [u],
                }));
              })
            )
            .subscribe({
              next: (threads) => {
                this.chatService.registerThreads(threads);
              },
            });
      }
    })

    this.initUserService
      .initCurrentUser()
      .pipe(
        map<User, IChatUser>((user) => ({
          id: user.id,
          name: `${user.firstName} ${user.lastName}`,
          uid: `u_${user.id}`,
        }))
      )
      .subscribe({
        next: (user) => {
          console.log("Initiating chat service");
          this.chatService.connect(user, false);

          setInterval(() => {
            this.chatService.reconnect();
          }, 1000 * 5);
        },
      });
  }

  initMenu() {
    this.pagesMenu
      .getMenu()
      .pipe(takeWhile(() => this.alive))
      .subscribe((menu) => {
        this.menu = menu;
      });
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

  closeChatApp() {
    this.sidebarService.collapse('right');
  }

  initChatApp() {
    // const inActiveOb = this.sidebarService
    //   .onCollapse()
    //   .pipe(filter(({ tag }) => tag == 'right'))
    //   .pipe(map((_) => false));
    // const activeOb = this.sidebarService
    //   .onExpand()
    //   .pipe(filter(({ tag }) => tag == 'right'))
    //   .pipe(map((_) => true));
    // const toggleOb = this.sidebarService
    //   .onToggle()
    //   .pipe(filter(({ tag }) => tag == 'right'))
    //   .pipe(map((_) => !this.isChatActive.value));
    // merge(inActiveOb, activeOb, toggleOb).subscribe(this.isChatActive);
    const onCollapse$ = this.sidebarService.onCollapse().pipe(
      filter(({ tag }) => tag == 'right'),
      map(() => () => false)
    );
    const onExpand$ = this.sidebarService.onExpand().pipe(
      filter(({ tag }) => tag == 'right'),
      map(() => () => true)
    );
    const onToggle$ = this.sidebarService.onToggle().pipe(
      filter(({ tag }) => tag == 'right'),
      map(() => (state) => !state)
    );
    merge(onCollapse$, onExpand$, onToggle$)
      .pipe(scan((state: boolean, f: (state?: boolean) => boolean) => f(state), false))
      .subscribe(this.isChatActive);
  }
}
